<template>
  <div class="componentBox">
    <h2 class="componentTitle">放养信息</h2>
    <h3 class="littleTitle">放养情况</h3>
    <p style="margin-left: 20px;">放养次数(次)：{{ stockingInfoDetailDTOList.length }}</p>
    <Table style="padding: 0 20px;" :columns="stockingInfoCol" :list="stockingInfoList" />
    <h3 class="littleTitle" style="margin-top: 20px;">放养明细</h3>
    <Tabs style="padding: 0 20px;" :columns="stockingCol" :list="stockingInfoDetailDTOList" />
    <h3 class="littleTitle" style="margin-top: 20px;">用料信息</h3>
    <Table style="padding: 0 20px;" :columns="feedInfoCol" :list="detail.feedInfoList" url="/nhf-compound-editor"/>
  </div>
</template>

<script>
import Table from './Table.vue';
import Tabs from './Tabs.vue'
export default {
  components: {Table,Tabs},
  props: ['detail'],
  data() {
    return {
      numbers: ['零','一','二','三','四','五','六','七','八','九',],
      stockingInfoCol: [
        {
          title: '品种类型',
          dataIndex: 'varietyType',
          width: 120,
          ellipsis: true,
          scopedSlots: { customRender: 'name' },
        },
        {
          title: '品种数(个)',
          dataIndex: 'varietyNum',
          width: 120,
          ellipsis: true,
          scopedSlots: { customRender: 'fixed' },
        },
        {
          title: '数量(尾)',
          dataIndex: 'num',
          width: 120,
          ellipsis: true,
          scopedSlots: { customRender: 'fixed' },
        },
        {
          title: '重量(斤)',
          dataIndex: 'weight',
          width: 120,
          ellipsis: true,
          scopedSlots: { customRender: 'fixed' },
        },
      ],
      stockingCol: [
        // {
        //   title: '时间',
        //   dataIndex: 'date',
        //   width: 140,
        //   ellipsis: true,
        //   scopedSlots: { customRender: 'name' },
        // },
        {
          title: '品种',
          dataIndex: 'varietyName',
          width: 120,
          ellipsis: true,
          scopedSlots: { customRender: 'name' },
        },
        {
          title: '类型',
          dataIndex: 'varietyLabelName',
          width: 120,
          ellipsis: true,
          scopedSlots: { customRender: 'name' },
        },
        {
          title: '规格(尾/斤)',
          dataIndex: 'stockingSpecification',
          width: 120,
          ellipsis: true,
          scopedSlots: { customRender: 'fixed' },
        },
        {
          title: '数量(尾)',
          dataIndex: 'stockingNum',
          width: 120,
          ellipsis: true,
          scopedSlots: { customRender: 'fixed' },
        },
        {
          title: '重量(斤)',
          dataIndex: 'stockingWeight',
          width: 120,
          ellipsis: true,
          scopedSlots: { customRender: 'fixed' },
        },
      ],
      feedInfoCol: [
        {
          title: '饲料品牌',
          dataIndex: 'feedBrand',
          width: 120,
          ellipsis: true,
          scopedSlots: { customRender: 'name' },
        },
        {
          title: '料号/品种',
          dataIndex: 'productName',
          width: 120,
          ellipsis: true,
          scopedSlots: { customRender: 'scanDetail' },
        },
        {
          title: 'NHModel名称',
          dataIndex: 'modelName',
          width: 120,
          ellipsis: true,
          scopedSlots: { customRender: 'name' },
        },
        {
          title: 'NHModel代码',
          dataIndex: 'modelCode',
          width: 120,
          ellipsis: true,
          scopedSlots: { customRender: 'name' },
        },
        {
          title: '饲料终端价格(元/吨)',
          dataIndex: 'feedTerminalPrice',
          width: 120,
          ellipsis: true,
          scopedSlots: { customRender: 'fixed' },
        },
        {
          title: '总耗料量(吨)',
          dataIndex: 'feedCost',
          width: 120,
          ellipsis: true,
          scopedSlots: { customRender: 'fixed' },
        },
      ],
    }
  },
  watch: {},
  computed: {
    stockingInfoList(){
      let lst = []
      let {stockingInfo={}} = this.detail || {}
      let fieldArr = [
        {name: '吃食鱼',field: 'eatFood'},
        {name: '滤食鱼',field: 'filterFood'},
        {name: '总计',field: 'totalStocking'},
      ]
      lst = fieldArr.map(el => {
        return {
          varietyType: el.name,
          varietyNum: stockingInfo[`${el.field}VarietyNum`],
          num: stockingInfo[`${el.field}Num`],
          weight: stockingInfo[`${el.field}Weight`],
        }
      })
      return lst
    },
    stockingInfoDetailDTOList(){
      let {stockingInfoDetailDTOList=[]} = this.detail || {}
      stockingInfoDetailDTOList = stockingInfoDetailDTOList.map((el,i) => {
        let cs = el.details.filter(el => el.varietyLabelCode === 'chishi') || []
        let ls = el.details.filter(el => el.varietyLabelCode === 'lvshi') || []
        let csNum = 0,
        lsNum = 0,
        csWeight = 0,
        lsWeight = 0
        cs.forEach(el => {
          csNum += Number(el.stockingNum || 0)
          csWeight += Number(el.stockingWeight || 0)
        })
        ls.forEach(el => {
          lsNum += Number(el.stockingNum || 0)
          lsWeight += Number(el.stockingWeight || 0)
        })
        csWeight = csWeight.toFixed(this.len)
        lsWeight = lsWeight.toFixed(this.len)
        let stockingNum = 0,stockingWeight = 0
        el.details.map(item => {
          stockingNum += Number(item.stockingNum || 0)
          stockingWeight += Number(item.stockingWeight || 0)
          item.date = el.stockingDate
          return item
        })
        el.title = `第${this.numbers[i+1]}次`
        el.csNum = csNum
        el.lsNum = lsNum
        el.csWeight = csWeight
        el.lsWeight = lsWeight
        el.details.push(
          {
            varietyName: '总计',
            stockingNum: Number(stockingNum).toFixed(this.len),
            stockingWeight: Number(stockingWeight).toFixed(this.len),
          }
        )
        return el
      })
      return stockingInfoDetailDTOList
    },
    // feedInfoList(){}
  },
  created() {},
  mounted() {
    this.staffId=window.localStorage.getItem('staffId')
  },
  methods: {
    productDetail(record){
      this.$router.push({
        path: '/nhf-compound-editor',
        query: {
          id: record.nhfFormulaId
        }
      })
    }
  },
}
</script>
<style lang='scss'></style>
<style lang='scss' scoped></style>